var map = {
	"./0_01.png": "a1ac",
	"./0_02.png": "07d6",
	"./0_03.png": "7350",
	"./0_04.png": "cc1f",
	"./0_05.png": "0047",
	"./1688.png": "bf70",
	"./1688_2.png": "59b0",
	"./AfterSale1.png": "62df",
	"./AfterSale2.png": "0a65",
	"./AfterSale3.png": "fef1",
	"./Ali1688.png": "0047b",
	"./App.jpg": "ff61",
	"./ButtonDirect.png": "d85c",
	"./Guide00.jpg": "1610",
	"./Guide01.png": "d3fb",
	"./Guide02.png": "4a0b",
	"./Guide03.png": "efa0",
	"./Guide04.png": "e4f8",
	"./Guide05.png": "7de2",
	"./InvitationRegisterBg.png": "f4ee",
	"./Jd.png": "7b34",
	"./LODA.png": "0922",
	"./L_1.png": "f737",
	"./L_2.png": "4ff7",
	"./L_3.png": "8e2d",
	"./L_4.png": "076e",
	"./LodaWeChat.jpg": "118f",
	"./Pdd.png": "086f",
	"./ShoppingCart.png": "e0eb",
	"./Tao.png": "c0b9",
	"./UserBalance.png": "eb79",
	"./UserCoupon.png": "de37",
	"./UserLink.png": "a982",
	"./UserOrder.png": "be9b",
	"./VIP.png": "ca40",
	"./WingPay.png": "8803",
	"./alipay.png": "80d3",
	"./earth.png": "acf0",
	"./en.png": "414f",
	"./facebook.png": "0cab",
	"./google.png": "2f2a",
	"./google_play.png": "8d68",
	"./huawei.png": "b422",
	"./id.png": "04a1",
	"./ios_store.png": "f6bd",
	"./km.png": "f7ac",
	"./loda_2.png": "2651",
	"./loda_food.jpg": "1695",
	"./lodalogo.png": "66fa",
	"./login_banner_cn.jpg": "7a81",
	"./login_banner_cn_2.jpg": "0dcb",
	"./maintain.png": "0603",
	"./noCart.png": "3173",
	"./pddico.png": "8d6a",
	"./pe.png": "0996",
	"./pinduoduo.png": "e7db",
	"./qrCode.png": "b3fe",
	"./rightNav.png": "e6f1",
	"./seach.png": "3cef",
	"./successRegister.png": "3828",
	"./t_m.png": "2758",
	"./taobao.png": "af83",
	"./translate.png": "a2c8",
	"./weixin.png": "f57c",
	"./zh-cn.png": "a604",
	"./ztoworld.png": "40f4",
	"./ztoworld_logo.png": "903d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33db";